// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getProjects: '/catalog/project',
  opProject: '/catalog/project',
}

// get Projects
export async function getProjects(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getProjects
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`

        // el usuario lo hago objeto
        o.user = JSON.parse(o.user)

        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo proyectos',
        description: error.message,
      })
    })
}

// add new project
export async function postProject(token, project) {
  const url = fsConfig.root + fsConfig.opProject
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }

  // borra los campos auxiliares que no se graban
  delete project.sysdatajson.groups
  delete project.sysdatajson.users
  delete project.sysdatajson.userMaster

  return axios
    .post(url, project, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando proyecto',
        description: error.message,
      })
    })
}

export async function putProject(token, project) {
  const url = fsConfig.root + fsConfig.opProject
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = project
  delete project.key
  delete project.groups
  delete project.users
  delete project.userMaster
  delete project.user
  return axios
    .put(url, project, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      response.key = key
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error grabando proyecto',
        description: error.message,
      })
    })
}

export async function deleteProject(token, ProjectUid) {
  const url = `${fsConfig.root}${fsConfig.opProject}/${ProjectUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando proyecto',
        description: error.message,
      })
    })
}
